import React from 'react';
import { CopyFormStage } from './SessionsCopyDialog.types';
import { Grid } from '@material-ui/core';
import { useStyles } from './SessionsCopyDialog.styles';
import CheckIcon from '@material-ui/icons/Check';

interface CopyFormHeaderProps {
  currentStage: CopyFormStage;
}

export const CopyFormHeader: React.FC<CopyFormHeaderProps> = ({ currentStage }: CopyFormHeaderProps) => {
  const classes = useStyles();

  return (
    <Grid container style={{ width: '100%', display: 'inline-flex', justifyContent: 'center' }}>
      <div className={currentStage === CopyFormStage.BasicData ? classes.numberCircleInline : classes.checkOutline}>
        <div
          className={
            currentStage === CopyFormStage.BasicData ? classes.numbersInCirclesInline : classes.checkOutlineInside
          }
        >
          {currentStage === CopyFormStage.BasicData ? '1' : <CheckIcon />}
        </div>
      </div>
      <div className={currentStage === CopyFormStage.BasicData ? classes.textInline : classes.textOutline}>
        Wybór sesji <br />
        egzaminacyjnej
      </div>
      <hr className={classes.line}></hr>
      <div
        className={
          currentStage === CopyFormStage.SheetDefinition ? classes.numberCircleInline : classes.numberCircleOutline
        }
      >
        <div
          className={
            currentStage === CopyFormStage.SheetDefinition
              ? classes.numbersInCirclesInline
              : classes.numbersInCirclesOutline
          }
        >
          2
        </div>
      </div>
      <div className={currentStage === CopyFormStage.SheetDefinition ? classes.textInline : classes.textOutline}>
        Konfiguracja <br />
        sesji egzaminacyjnej
      </div>
    </Grid>
  );
};
